import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-areapersonale',
  templateUrl: './areapersonale.component.html',
  styleUrls: ['./areapersonale.component.scss']
})
export class AreapersonaleComponent implements OnInit {

  constructor(private route:Router, private confService: ConfigurazioneGeneraleService) {
  }

  ngOnInit(): void {
  }

  goToProfilo():void{
    void this.route.navigate(['/Impostazioni/user-info']);
  }

  goToIstanze():void{
    void this.route.navigate(['/Servizi/IstanzeEmesse']);
  }

  goToAppuntamenti():void{
    void this.route.navigate(['Appuntamenti/lista-prenotazioni']);
  }
  goToPreferiti():void{
    void this.route.navigate(['Impostazioni/gestione-preferiti']);
  }
  goToHome():void{
    window.location.href = this.confService.configurazione.linkHome;
  }
}
